__turbopack_context__.v({
  "slide": "style-module-scss-module__71tsjW__slide",
  "swiperContainer": "style-module-scss-module__71tsjW__swiperContainer",
  "swiperSlide": "style-module-scss-module__71tsjW__swiperSlide",
});
